module.exports = __webpack_public_path__ + "img/KinokoTable33.f08019e9.jpg";